import fixtures from './fixtures.json';
import Injectable from '@/modules/shared/domain/di/injectable';
import { CurrentUserRepository } from '../../../domain/repositories/current-user-repository';
import { UserEntity } from '../../../domain/entities/user-entity';

@Injectable()
export default class CurrentUserDummyRepository implements CurrentUserRepository {
  // eslint-disable-next-line class-methods-use-this
  get(): Promise<UserEntity> {
    return Promise.resolve(fixtures);
  }
}
